export enum SpinnerPlaceholderAlign {
  START = 'start',
  CENTER = 'center',
  END = 'end'
}
